/** Keeps the coaching goal and the highest-ranked distinct opportunities. */
export function buildHighlightedOpportunityCriterionIds(
  goalCriterionId: string | undefined,
  rankedOpportunityCriterionIds: readonly string[],
  availableCriterionIds: ReadonlySet<string>,
): Set<string> {
  const criterionIds = new Set<string>();
  if (
    goalCriterionId !== undefined &&
    availableCriterionIds.has(goalCriterionId)
  ) {
    criterionIds.add(goalCriterionId);
  }

  for (const criterionId of rankedOpportunityCriterionIds) {
    if (criterionIds.size === 4) break;
    if (availableCriterionIds.has(criterionId)) {
      criterionIds.add(criterionId);
    }
  }

  // A goal alone is not an opportunity list, so the table stays unfiltered.
  if (
    goalCriterionId !== undefined &&
    criterionIds.has(goalCriterionId) &&
    criterionIds.size === 1
  ) {
    return new Set<string>();
  }

  return criterionIds;
}
